// extracted by mini-css-extract-plugin
export default {"root":"EditGroupContestModalSidePanel_root__bcvx4"};